export default {
  namespaced: true,
  grid: {
    widgets: {
      alarms: {
        incoming_alarms: {
          title: "Alarmes em espera",
        },
        alarms_being_attended: {
          title: "Alarmes em atenção",
        },
        alarms_in_attention: {
          title: "Alarmes em atenção",
        },
        pagination: {
          showing: "Mostrando",
          records: "Registros",
          page: "Pág.",
          of: "de",
        },
        search: {
          placeholder: "Pesquisar por ID de alarme, endereço, inquilino, instalação, endereço...",
          placeholderSearchUnits: "Buscar instalação",
          placheholderMatches: "Buscar coincidencias"
        },
        menu: {
          confirm: "Confirme",
          attended: "Atendidos",
          cancel: "Cancelar",
          display: "Visualizar",
          send_to_seproban: "Enviar para seproban",
          bau: "BAU",
          incidents: "Incidentes",
          reports: "Reportes"
        },
        table: {
          no_data: "Não há informações disponíveis",
          restored_at: "Restabelecimento",
          rows: {
            1: "Alarme",
            2: "Dispositivo",
            3: "Instalação",
            4: "Estado",
            5: "Data",
          },
          popover: {
            alarm_id: "ID",
            alarm_type: "Tipo de alarme",
            facility: "Instalação",
            camera: "Dispositivo",
            date: "Data",
            taken_by: "Tomado por",
            not_available: "N/A",
            local_hour: "Local",
            central_hour: "Central"
          }
        },
      },
      units: {
        activate_digital_output: "Ativar saída digital",
        disable_digital_output: "Desativar saída digital",
        title: "Instalações",
        messages: {
          no_data: "Não há informações disponíveis",
        },
        pagination: {
          showing: "Mostrando",
          records: "Registros",
          page: "Pág.",
          of: "de",
        },
        search: {
          placeholder: "Pesquisar por estabelecimento, endereço...",
          results: "Resultados",
        },
        table: {
          rows: {
            1: "Nome",
          },
        },
        subsystems_tree: {
          info: "Informações",
          video: {
            title: "Video",
            live_video: "Video ao vivo",
            recorded_video: "Video gravado",
            timeline: "Linha do tempo",
          },
          voip: {
            make_call: "Chamada",
          },
          activate_digital_output: "Ativar saída digital",
          disable_digital_output: "Desativar saída digital",
        },
      },
      layouts: {
        title: "Layouts",
      },
      views: {
        title: "Visualizações",
      },
      widgets: {
        title: "Widgets",
      },
      charts: {
        title: "Gráficos",
        no_data: "Nenhum dado disponível",
      },
      videowall: {
        title: "Videowall",
      },
      scripts: {
        title: "Comandos",
      },
    },
    modals: {
      alarms_status: {
        title_confirm: "Tem certeza de que deseja enviar o alarme?",
        title_attended: "Tem certeza de que atendeu o alarme?",
        title_cancel: "Tem certeza que deseja cancelar o alarme?",
        protocol: "Protocolo",
        comments: "Comentários",
        alarm_level: "Nível de alarme",
        btns: {
          send: "Mandar",
          cancel: "Cancelar",
        },
        fromSameFacility: "Da mesma instalação",
        fromSameAlarmType: "Do mesmo tipo de alarme",
        fromSameSector: "Do mesmo setor"
      },
      update_layout: {
        cameras: "Câmaras",
        pre_alarm: "Pré-alarme",
        info: "Informações",
        alarm_info: "Informações de alarme",
        unit_info: "Informações de instalação",
        plane: "Plano",
        unit_plane: "Mostrar plano de la instalação",
        map: "Mapa",
        alarm_location: "Localização do alarme",
        unit_location: "Localização do instalação",
        gps: "GPS",
        locations: "Localizações",
        select_slot: "Selecciona um espaço",
        btns: {
          ok: "Ok",
        },
      },
    },
    tabs: {
      new_tab: "Nova aba",
      context_menu: {
        save_as_view: "Salvar como visualização",
        update_view: "Atualizar visualização",
        update_name: "Mudar de nome",
      },
      alert: {
        title: "Alerta de abas",
        text: "O número máximo de abas permitidas é {max}."
      }
    },
    timeline: {
      waiting_for_main_camera: "Esperando pela câmera principal",
      no_footage_available: "Nenhuma filmagem disponível para o tempo selecionado",
      toolbar: {
        alarms: "Alarmes",
        objects: "Objetos",
        filter_type: "Clique para procurar objetos",
        zoom_in: "Mais Zoom",
        zoom_out: "Diminuir Zoom",
        x_seconds_fw: "5 segundos à frente",
        x_seconds_bw: "5 segundos atrás",
        play: "Reproducir",
        pause: "Pausar",
        synchronize: "Sincronizar",
        desynchronize: 'Dessincronizar',
        download: 'Baixar video',
        mostRecentEvent: 'Evento mais recente',
        speed: "Velocidade",
        facialRecognitionEnrollment: "Registro de reconhecimento facial",
      },
      objectsModal: {
        title: "Pesquisar por objetos",
        field1: {
          label: "Fornecedor",
        },
        field2: {
          label: "Tipo",
        },
        field3: {
          label: "De",
        },
        field4: {
          label: "Para",
        },
        field5: {
          label: "Objeto",
        },
        operators: {
          equal_to: "igual a",
          not_equal_to: "diferente de",
          contains: "contém",
          not_contains: "não contém",
          gt: "maior que",
          lt: "menor que",
          gte: "maior ou igual a",
          lte: "menor ou igual a",
          is_in: "está em",
          is_not_in: "não está em",
        },
      },
      downloadModal: {
        title: 'Baixar vídeos',
      },
    },
    frame: {
      url: "url",
    },
    slots: {
      main: {
        messages: {
          widget_not_be_added: "Não foi possível adicionar widget",
          timeline_widget_exists: "Já existe um widget do tipo Timeline",
          chat_widget_exists: 'Este chat já foi carregado',
          detection_event_widget_exists: 'Já existe um widget do tipo Timeline Detecção de eventos',
          empty_text: 'Arraste e solte câmeras, mapas e widgets aqui'
        },
      },
      info: {
        unit: "Instalação",
        address: "Direção",
        actions: "Ações",
        btns: {
          confirmed: "Confirme",
          attended: "Participou",
          cancel: "Cancelar",
          reopen: "Reabrir alarme",
        },
        description: "Descrição",
        company: "Companhia",
        latitude: "Latitud",
        longitude: "Longitud",
        exterior_number: "Número exterior",
        suburb: "Colônia",
        municipality: "Cidade",
        postal_code: "C.P.",
        country: "País",
        region: "Estado",
        tracing: "Rastreando",
        protocol: "Protocolo",
        attending_comments: "Motivo de atenção",
        solved_comments: "Motivo de solução",
        cancel_comments: "Motivo de cancelamento",
        status: "Status",
        folio_cad: "Folha CAD",
        data: "Informação adicional",
        camera: {
          review_start: "Início da revisão",
          review_end: "Fim de revisão",
          events_review: "Revisão de eventos",
          center: "Eixo",
          sector: "Setor",
          previous_time: "Vez anterior",
          later_time: "Mais tarde",
          reseller: {
            name: "Nome",
            company: "Companhia",
          },
          bridge: {
            account_id: "Account Id",
            bridge_id: "Bridge Id",
            device_name: "Nome do dispositivo",
          },
          bridge_account: {
            account_id: "Account Id",
            name: "Nome",
          },
        },
        sip_call: {
          state: "Estado",
          from: "Desde",
          to: "Em direção a",
          make_call: "Chamadar",
          origin_date: "Data de origem",
          audio_record: "Gravação",
        },
        fr: {
          title: "Reconhecimento facial",
          enrolled_person: "Pessoa inscrita",
          face_detected: "Rosto detectado",
          detection: "Detecção",
          camera_name: "Nome da câmera",
          person_name: "Nome do indivíduo",
          list_name: "Lista de nomes",
          age: "Era",
          gender: "Gênero",
          emotion: "Emoção capturada",
          glasses: "Uso de óculos",
          picture_quality: "Qualidade da imagem",
          blurriness: "Imprecisão",
          darkness: "Trevas",
          brightness: "Brilhar",
          saturation: "Saturação",
          score: "Pontuação de retrato",
          similarity: "Pontuação de similaridade",
          match_history: "Histórico de partidas",
          waiting_detection: "Esperando pela detecção",
          welcome: "Bem-vindo",
          genderFemale: 'Fêmea',
          genderMale: 'Masculino',
        },
        detection_events: {
          default: {
            title: "Evento de detecção",
          },
          lpr: {
            title: "Reconhecimento de placas",
          },
          loitering: {
            title: "Vadiagem",
          },
          crowded: {
            title: "Aglomeração",
          },
          fr: {
            title: "Reconhecimento facial",
          },
          people_counting: {
            title: "Contagem de pessoas",
          },
          people_entering: {
            title: "Pessoas entrando",
          },
          people_exiting: {
            title: "Pessoas namorando",
          },
          prohibited_parking: {
            title: "Estacionamento proibido",
          },
          vehicle_count: {
            title: "Contagem de veículos",
          },
          wrong_way: {
            title: "Sentido contrário",
          },
          delimited_zone: {
            title: "Segurança de perímetro",
          },
          person_fallen: {
            title: "Pessoa deitada",
          },
          smart_motion_detection: {
            title: "Smart Motion Detection",
          },
          object_count: {
            title: "Contagem de Objetos",
          },
          person_in_area: {
            title: 'Pessoa na área'
          },
          intrusion: {
            title: 'Intrusão'
          },
          tripwire: {
            title: 'Cruzamento de linha'
          },
          labels: {
            overall_picture: "Visão geral",
            plate: "Placa",
            camera_name: "Nome da câmera",
            city: "Cidade",
            date: "Data de captura",
            speed: "Velocidade",
            brand: "Marca",
            model: "Modelo",
            color: "Cor",
            class: "Classe",
            list: "Lista",
            confidence: "Confiabilidade",
          },
        },
        sip: {
          title: "Chamada SIP",
          session_id: "Identificação de sessão",
          state: "Status",
          from: "Desde a",
          to: "uma",
        },
        workflow_logs: {
          title: "Registro de fluxo de trabalho",
          no_workflow_data: "Nenhum dado de workflow disponível"
        },
        analytic_record: {
          title: "Registro Analítico",
          alarm_category: "Categoría de alarme",
          camera_name: "Nome da câmera",
          matched_rules: "Regras de correspondência",
          priority: "Prioridade",
        },
        sensors: {
          title: "Sensores",
          type: "Tipo",
          measurement: "Medição de Alarme",
          high_critical: "Medição Alta Crítica",
          high_warning: "Aviso Alto de Medição",
          low_critical: "Medição Baixa Crítica",
          low_warning: "Aviso de Medição Baixa",
        },
        emergency_contacts: "Contatos de Emergência",
        no_emergency_contacts: "Esta unidade não tem contatos de emergência",
        contact_info: {
          name: "Nome",
          phone: "Telefone",
          description: "Descrição"
        },
        general_summary: "Resumo Geral",
        facility_detail: "Detalhes da Instalação",
        risk_evaluation: "Avaliação de Risco",
        cad_data: "C5 - CAD",
        institutions: "Instituições",
        alarm_groups: "Grupos de Alarme",
        smart_detection: "Smart Detection",
        lpr: "LPR",
        analytic_record_title: "Registro Analítico",
        sip_calls: "Chamadas SIP",
        pbx_calls: "Chamadas PBX",
        mobotix: "Mobotix / ME",
        alarm_bridge_data: "Dados de Bridge de Alarme",
        default_detection: "Detecções",
        action_plan_log: "Log do Plano de Ação",
        incident_log: "Log de Incidentes",
        comments: "Comentários",
        unit_title: "Unidade",
        camera_title: "Câmera",
        swift_sensor: "Sensor Swift",
        swift_sensor_tree: "Sensor Swift (Árvore)",
        actuator: "Atuador",
        generic_device: "Dispositivo Genérico",
        alarm_id: "ID do Alarme",
        creation_date: "Data de Criação",
        risk_percentage: "Porcentagem de risco",
        cad_folio: "Folha CAD",
        answer_call: "Responder",
        copy_id: "Copiar ID",
        copied: "Copiado!",
        pdf_export: "Exportar PDF",
        no_comments_yet: "Sem comentários ainda",
        write_comment_here: "Escreva um comentário aqui"
      },
      interphone: {
        type: "Tipo",
        alarm: "Alarme",
        created: "Criado",
        updated: "Atualizada",
        user: "Usuário",
      },
    },
    widgets_section: {
      weather: {
        title: "Clima",
        errorGelocation: "Não foi possível obter a localização",
        permissionDenied:
          "O acesso ao local não foi permitido, ative as permissões no seu dispositivo",
      },
      face_detection: {
        title: "Pesquisa facial",
      },
      map: {
        title: "Mapa",
      },
      chart: {
        title: 'Gráfico',
      },
      detection_event: {
        title: 'Detecção de eventos'
      },
      neo_dash: {
        title: 'Neo4j Relatórios',
        predefined_question: 'Perguntas predefinidas',
        cameras: 'Câmeras',
        cameras_placeholder: 'Selecione uma ou mais câmeras',
        colors: 'Cores',
        colors_placeholder: 'Selecione uma ou mais cores',
        time_range: 'Intervalo de tempo',
        last_days: 'Últimos {n} dias',
        all_time: 'Todo o histórico',
        plate_route_placeholder: 'Placa (ex. ABC123)',
        min_speed_label: 'Velocidade mínima (km/h)',
        min_speed_placeholder: '50',
        window_seconds_label: 'Janela de tempo (segundos)',
        window_seconds_placeholder: '10',
        questions: {
          cars_by_day: 'Quantos carros passaram por dia?',
          cars_by_color: 'Quantos carros por cor? (um grafo por cor)',
          cars_by_hour: 'Em quais horários passam mais/menos carros?',
          cars_by_camera: 'Quantos carros cada câmera detectou?',
          vehicle_types: 'Que tipos de veículos passaram?',
          vehicle_brands: 'Que marcas passaram?',
          top_plates: 'Top 10 placas mais detectadas',
          plates_registered: 'Quantas placas estão registradas?',
          camera_flow: 'Quais são as rotas mais comuns entre câmeras?',
          plate_clones: 'Quais placas parecem clonadas ou mal lidas? (vinculadas a mais de um veículo)',
          plate_route: 'Por onde essa placa se movimentou?',
          over_speed: 'Quais placas excedem o limite de velocidade?',
          exposure_time: 'Em quais locais o tráfego tem mais tempo de exposição?',
          repeat_rate: 'Qual % do público é novo vs. recorrente?',
          new_vs_repeat_hour: 'Em quais horários predomina público novo vs. conhecido?',
          convoy: 'Quais placas são detectadas juntas, em poucos segundos, em mais de uma câmera?',
        },
        report: {
          detections: 'Detecções',
          plate: 'Placa',
          vehicle: 'Veículo',
          vehicles: 'Veículos associados',
          empty: 'Sem dados no intervalo selecionado',
          error: 'Não foi possível carregar o relatório',
          no_plate_image: 'Sem imagem',
          no_detections: 'Sem detalhes de deteção para esta placa',
          brand: 'Marca',
          type: 'Tipo',
          vehicle_color: 'Cor do veículo',
          plate_color: 'Cor da placa',
          speed: 'Velocidade',
          direction: 'Direção',
          camera: 'Câmera',
          date: 'Data',
          top_routes: 'Principais rotas por esta câmera',
          clone_alert: 'Possível clonagem: esta placa está vinculada a mais de um veículo distinto',
          convoy_alert: 'Detectada junto a outra(s) placa(s) em mais de uma câmera: possível comboio',
          convoy_partners: 'Viaja junto com',
          convoy_partner_detail: '{plate} ({count}x em {cameras} câmeras)',
          speeding_alert: 'Excesso de velocidade: até {speed} km/h registrados',
          avg_speed: 'Velocidade média',
          exposure_index: 'Índice de exposição',
          total_plates: 'Placas totais',
          new_plates: 'Placas novas',
          repeat_plates: 'Placas recorrentes',
          repeat_rate: 'Taxa de recorrência',
          business_hint: {
            cars_by_camera: 'Compare o tráfego entre localizações para justificar tarifas de outdoor diferenciadas por local.',
            cars_by_day: 'Escolha 90 dias ou Todo o histórico para ver a tendência de crescimento do tráfego e justificar renovações.',
            cars_by_hour: 'Identifique os horários de maior tráfego para decidir quando rodar os anúncios em telas digitais.',
            vehicle_brands: 'A combinação de marcas indica o poder aquisitivo do público: útil para vender o espaço a marcas premium ou de massa.',
            vehicle_types: 'Se predominam veículos comerciais, esse local é mais atrativo para marcas B2B ou de logística.',
            exposure_time: 'O índice de exposição combina volume e velocidade média: quanto maior, mais tempo esse público vê o anúncio.',
            repeat_rate: 'Muito público novo favorece uma mensagem de descoberta; muito recorrente favorece uma de lembrança de marca.',
            new_vs_repeat_hour: 'Use isso para decidir qual mensagem exibir nas telas digitais conforme o horário do dia.',
          },
          node_types: {
            camera: 'Câmeras',
            plate: 'Placas',
            plate_clone: 'Placas (possível clonagem)',
            plate_speeding: 'Placas (excesso de velocidade)',
            plate_convoy: 'Placas (viajam juntas)',
            vehicle: 'Veículos',
          },
          chart_mode: {
            graph: 'Grafo',
            bar: 'Barras',
            pie: 'Pastel',
          },
          timeline: {
            show_all: 'Ver tudo',
            up_to: 'Até: {date}',
          },
        },
        color_names: {
          red: 'Vermelhos',
          green: 'Verdes',
          blue: 'Azuis',
          white: 'Brancos',
          black: 'Pretos',
          yellow: 'Amarelos',
          gray: 'Cinzas',
          silver: 'Prateados',
          orange: 'Laranjas',
          brown: 'Marrons',
          beige: 'Bege',
          gold: 'Dourados',
        },
        dashboard: {
          title: 'Resumo geral',
          total: 'Detecções',
          plates: 'Placas distintas',
          peak_hour: 'Horário de pico',
          top_color: 'Cor mais comum',
          range_all: 'Tudo',
          detections: 'Detecções',
          by_day: 'Detecções por dia',
          by_hour: 'Detecções por hora',
          by_color: 'Por cor',
          by_type: 'Por tipo de veículo',
          by_brand: 'Por marca',
          by_camera: 'Detecções por câmera',
          error: 'Não foi possível carregar o resumo',
        },
        graph: {
          title: 'Grafo de trajetória',
          plate: 'Placa',
          plate_placeholder: 'Placa (vazio = a mais detectada)',
          error: 'Não foi possível carregar o grafo',
          lib_error: 'Não foi possível carregar a biblioteca de grafo (NVL)',
        },
      },
    },
    saveLayout: {
      title: "Salvar layout",
      messages: {
        success: "Layout salvo com sucesso",
        error: "Erro ao salvar o layout",
      }
    },
    face_search: {
      title: 'Pesquisa facial Ntechlab',
    },
    add_slot: {
      title: 'Adicionar Slot',
    }
  }
}

